import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../app/state/app.selectors';
import * as fromPaymentFoundationTrustee from './payment-foundation-trustee.reducers';

export interface PaymentFoundationTrusteeState {
  stateData: fromPaymentFoundationTrustee.State;
}

export interface State extends fromRoot.AppState {
  PaymentFoundationTrustee: PaymentFoundationTrusteeState;
}

export const reducers = {
  stateData: fromPaymentFoundationTrustee.reducer
};

export const selectPaymentFoundationTrusteeState = createFeatureSelector<PaymentFoundationTrusteeState>('paymentFoundationTrustee');

export const selectPaymentFoundationTrusteeStateData = createSelector(selectPaymentFoundationTrusteeState, (state: PaymentFoundationTrusteeState) => state.stateData);

export const getPaymentFoundationTrusteeState = createSelector(selectPaymentFoundationTrusteeStateData, fromPaymentFoundationTrustee.getStateData);

export const getProcessedPaymentFoundationTrusteeState = createSelector(selectPaymentFoundationTrusteeStateData, fromPaymentFoundationTrustee.getProcessedData);

export const getPaymentFoundationTrusteeScreenError = createSelector(selectPaymentFoundationTrusteeStateData, fromPaymentFoundationTrustee.getError);

export const getPaymentFoundationTrusteeScreenPending = createSelector(selectPaymentFoundationTrusteeStateData, fromPaymentFoundationTrustee.getPending);